import type { JSX } from 'react'

import type { InstagramPreviewProfile } from '~publish/components/Composer/InstagramPreview/types'
import { PREVIEWS_MAP } from '~publish/legacy/composer/composer/components/post-preview/previews'
import type { DraftPreview } from '~publish/legacy/composer/composer/components/post-preview/previews/types'

export function ChannelPostPreview({
  service,
  draft,
  profile,
}: {
  service: string
  draft: DraftPreview
  profile: InstagramPreviewProfile
}): JSX.Element | null {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const preview = PREVIEWS_MAP[service] || null
  if (!preview) return null

  const { Preview: PreviewComponent } = preview

  return <PreviewComponent draft={draft} profile={profile} />
}
